import React, { useRef, useState, useCallback, useEffect } from 'react';
import get from 'lodash/get';

const DEBOUNCE_DELAY = 150;

const useMenuPosition = isConsentHasMultipleOutcomes => {
  const buttonRef = useRef(null);

  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });

  const getMenuPosition = useCallback(() => {
    if (isConsentHasMultipleOutcomes) {
      const button = get(buttonRef, 'current.button', null);

      const rect = button.getBoundingClientRect();

      const { x, y, width } = rect;

      setPosition({ top: y, left: x, width });
    }
  }, [isConsentHasMultipleOutcomes]);

  useEffect(() => {
    let timeoutId;

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        getMenuPosition();
      }, DEBOUNCE_DELAY);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { getMenuPosition, buttonRef, position };
};

export default useMenuPosition;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/ConsentDetailsPopup/MultipleOutcomesMenu/hooks/useMenuPosition.js